import type { RetainerPreviewRequest } from '@common/types/retainerPreviewRequest';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export async function fetchRetainerPreviewPdf(
    fileId: string,
    body: RetainerPreviewRequest,
): Promise<Blob> {
    const response = await fetch(`${BASE_URL}/api/v1/files/${fileId}/WordToPdf/preview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`Retainer preview failed (${response.status})`);
    }

    return response.blob();
}
